import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";
import "../../../assests/css/students/eventpage/eventcard.css";

function EventCards() {
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);
  const [events, setEvents] = useState([]);

  // Fetch events from backend (same API jo Admin panel use karta hai)
  const fetchEvents = () => {
    axios
      .get(`${baseUrl}/admin/events/viewAllEvents`)
      .then((response) => {
        setEvents(response.data.events || []);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  // Agar data na ho to marquee empty na dikhe
  if (events.length === 0) {
    return null; // ya loading/empty state daal saktay hain
  }

  // Marquee ke liye array ko duplicate kerna (seamless loop ke liye)
  const marqueeCards = [...events, ...events];

  return (
    <section className="ec-cards-section">
      <Container>
        <Row>
          <Col className="text-center">
            <h2 className="ec-section-heading">What You'll Get</h2>
            <p className="ec-section-subheading">
              Everything included when you join this event
            </p>
          </Col>
        </Row>

        <div className="ec-marquee-container">
          <div className="ec-marquee-track">
            {marqueeCards.map((event, index) => (
              <Card key={index} className="ec-card">
                <Card.Img
                  variant="top"
                  src={`${baseUrlForFiles}/${event.card_image}`}
                  alt={event.card_title}
                  className="ec-card-image"
                />

                <Card.Body className="ec-card-body">
                  <Card.Title className="ec-card-title">
                    {event.card_title}
                  </Card.Title>

                  <Card.Text className="ec-card-text">
                    {event.card_description}
                  </Card.Text>
                </Card.Body>
              </Card>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}

export default EventCards;